/* eslint-disable react/prop-types */
import React from 'react';
import {
  Card, Col, Container, Row,
} from 'react-bootstrap';
import '../alert-form.css';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faPencil } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import {
  selectIsEditingAlertForm,
  selectSensorsData,
  selectThresholdData,
} from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import { selectRoomAlertDeviceList, selectSensorMap } from '../../../../redux/slices/deviceList/deviceListSlice';
import { getChannelDisplayData } from '../../../../utility/channelUtils';
import MultiAlertGraph from '../../../common/AlertGraph/MultiAlertGraph';
import { AlertCountText } from './SelectedSensors';
import { selectAllThresholdRanges } from '../../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';
import { getAlertGraphThresholdConfig } from '../AlertFormUtility';
// import { selectChannelList } from '../../../../redux/slices/channelListSlice/channelListSlice';

const SingleSensorSummary = ({
  channels,
  deviceList,
  sensorMap,
  graphChannelKeys,
  graphColorMap,
  graphedAlertConfig,
  isEdit,
}) => (
  <>
    <Row>
      <Col className="col-md-12 col-lg-6">
        {channels.map((channel) => {
          const {
            key, deviceName, sensorName, port, channelName,
          } = getChannelDisplayData(channel, deviceList, sensorMap);
          return (
            <React.Fragment key={key}>
              <Row>
                <Col>
                  {`${deviceName} > `}
                  <strong>{sensorName}</strong>
                  {` (${port}) > ${channelName}`}
                </Col>
              </Row>
              {!isEdit && (
              <Row className="mt-2">
                <Col>
                  <AlertCountText alertCount={1} />
                </Col>
              </Row>
              )}
            </React.Fragment>
          );
        })}
      </Col>

      <Col className="col-md-12 offset-lg-1 col-lg-5">
        <MultiAlertGraph
          channelKeys={graphChannelKeys}
          alertConfig={graphedAlertConfig}
          colors={graphColorMap}
          showDateToggle={false}
        />
      </Col>
    </Row>
  </>
);

const MultiSensorSummary = ({
  selectedChannels, deviceList, sensorMap, graphChannelKeys, graphColorMap, graphedAlertConfig,
}) => (
  <>
    <Row className="mb-4">
      <Col className="col-md-12 col-lg-6">
        <Container
          className="p-2 m-0"
          style={{
            height: '100px',
            border: '1px solid #ccc',
            overflowY: 'scroll',
          }}
        >
          <div>
            {selectedChannels.map((channel) => {
              const {
                key, deviceName, sensorName, port, channelName,
              } = getChannelDisplayData(channel, deviceList, sensorMap);
              const isGraphed = graphChannelKeys.includes(key);

              return (
                <div key={key}>

                  {isGraphed && (
                  <FontAwesomeIcon
                    icon={faCircle}
                    color={graphColorMap[key]}
                    className="mr-2"
                  />
                  )}

                  {`${deviceName} > `}
                  <strong>{sensorName}</strong>
                  {` (${port}) > ${channelName}`}
                </div>
              );
            })}
          </div>
        </Container>
        <AlertCountText alertCount={selectedChannels.length} />
      </Col>
      <Col className="col-md-12 offset-lg-1 col-lg-5">
        <MultiAlertGraph
          channelKeys={graphChannelKeys}
          alertConfig={graphedAlertConfig}
          colors={graphColorMap}
          showDateToggle={false}
        />
      </Col>
    </Row>
  </>
);

function SelectSensorsSummary({ onEdit = null }) {
  const {
    selectedChannels,
    graphedChannels,
    graphedChannelColors,
    graphedAlertConfig,
  } = useSelector(selectSensorsData);
  const sensorMap = useSelector(selectSensorMap);
  const deviceList = useSelector(selectRoomAlertDeviceList);
  // const rawChannelList = useSelector(selectChannelList);
  const isEdit = useSelector(selectIsEditingAlertForm);
  const {
    thresholdValue,
    thresholdOperator,
    useSharedThreshold,
    thresholdId,
  } = useSelector(selectThresholdData);
  const sharedThresholds = useSelector(selectAllThresholdRanges);
  const alertConfig = {
    ...graphedAlertConfig,
    threshold: getAlertGraphThresholdConfig(
      useSharedThreshold,
      thresholdId,
      sharedThresholds,
      thresholdValue,
      thresholdOperator,
    ),
  };
  const channels = selectedChannels;
  const channelCount = channels.length;
  if (channelCount === 0) return <></>;

  const graphChannelKeys = graphedChannels;

  const graphColorMap = Object.fromEntries(
    graphedChannels.map((key) => [key, graphedChannelColors[key]]),
  );
  if (!selectedChannels.length) return null;

  return (
    <Card className="alert-card">
      <Card.Body>
        <Row className="align-items-center">
          <Col>
            <Card.Title className="mb-0">{selectedChannels.length > 1 ? 'Sensors:' : 'Sensor:'}</Card.Title>
          </Col>
          <Col className="text-right">
            {/* eslint-disable-next-line react/button-has-type */}
            {
              onEdit && (
              <FontAwesomeIcon
                className="btn btn-link"
                onClick={onEdit}
                icon={faPencil}
              >
                Edit
              </FontAwesomeIcon>
              )
            }
          </Col>
        </Row>
        {
          selectedChannels.length === 1
            ? (
              <SingleSensorSummary
                channels={channels}
                deviceList={deviceList}
                sensorMap={sensorMap}
                graphChannelKeys={graphChannelKeys}
                graphColorMap={graphColorMap}
                graphedAlertConfig={alertConfig}
                isEdit={isEdit}
              />
            )
            : (
              <MultiSensorSummary
                selectedChannels={channels}
                deviceList={deviceList}
                sensorMap={sensorMap}
                graphChannelKeys={graphChannelKeys}
                graphColorMap={graphColorMap}
                graphedAlertConfig={alertConfig}
              />
            )
        }
      </Card.Body>
    </Card>
  );
}
SelectSensorsSummary.defaultProps = {
  onEdit: null,
};
SelectSensorsSummary.propTypes = {
  onEdit: PropTypes.func,
};
export default SelectSensorsSummary;
